<div class="title">Exportando...</div>
<div class="tasks">
    @for (task of tasks; track task.uuid) {
        <app-export-overlay-task [task]="task"></app-export-overlay-task>
    }
</div>
<button mat-button class="mx-auto" (click)="onHideButtonPressed()" matTooltip="Ocultar">
    <mat-icon [svgIcon]="'heroicons_outline:eye-slash'"></mat-icon>
    <span>Ocultar</span>
</button>
